import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';

import { SharedModule } from '../shared/shared.module';
import { FleetOverviewComponent } from './fleet-overview/fleet-overview.component';
import { routing } from './fleet.routing';

@NgModule({
    declarations: [FleetOverviewComponent],
    imports: [CommonModule, SharedModule, FormsModule, NgbNavModule, routing],
})
export class FleetModule {}
